import { Component, OnInit } from '@angular/core';
import { SimulationGoals } from '../../models/simulation';

@Component({
    selector: 'simulation-goals',
    templateUrl: './goals.component.html',
    styleUrls: ['../job-simulator/job-simulator.component.css'],
    standalone: false
})
export class GoalsComponent implements OnInit {
  goals: SimulationGoals = {};

  constructor() { }

  ngOnInit() {
  }

}
